<template>
    <v-content>
        <v-container fluid>
            <!-- <v-row no-gutters>
                 <v-col cols="10"></v-col>
                 <v-col cols="2">
                     <v-btn cols="2" class="success" @click.stop="onDownload">
                         <v-icon>get_app</v-icon>
                         Export
                     </v-btn>
                 </v-col>
             </v-row>-->
            <v-expansion-panels multiple hover v-model="panels">
                <v-expansion-panel>
                    <v-expansion-panel-header>{{$t('filter')}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-container fluid>
                            <div >
                                <v-row align="start" justify="start" class="mt-4">

                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-autocomplete v-model="serverParams.ReportType"
                                                        :items="ReportTypes"
                                                        :label="$t('report_type')"
                                                        clearable
                                                        dense
                                                        outlined
                                                        single-line
                                                        item-text="value"
                                                        item-value="value"></v-autocomplete>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-select :items="customYear"
                                                  :label="$t('select_year')"
                                                  v-model="serverParams.FromDate"
                                                  prepend-inner-icon="event"
                                                  dense
                                                  outlined></v-select>
                                        <!--<v-menu
                                                v-model="snackbar.menu1"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                :close-on-content-click="false"
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="serverParams.FromDate"
                                                        :label="$t('from_date')"
                                                        clearable
                                                        prepend-icon="event"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="serverParams.FromDate">

                                            </v-date-picker>
                                        </v-menu>-->
                                    </v-col>
                                    <v-col class="d-flex flex-sm-row flex-column" cols="12" sm="12">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mx-2" dark small color="primary" @click.stop="loadItems">
                                            <v-icon dark> search </v-icon>
                                            {{$t('search')}}
                                        </v-btn>
                                        <JsonExcelVue :fetch="fetchData" is-custom-header is-custom-data :customHeader="customHeader">
                                            <v-btn small class="success mx-4">
                                                <v-icon>get_app</v-icon>
                                                {{$t('download_to_excel')}}
                                            </v-btn>

                                        </JsonExcelVue>
                                        <v-spacer></v-spacer>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <table class="table tbl" v-if="rows.length > 0">
                <thead>
                    <tr>
                        <th>{{$t('table.name_of_institute')}}</th>
                        <th> {{$t('course')}} </th>
                        <th> {{$t('enrolled_student')}}</th>
                        <th> {{$t('passed_student')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="row in rows">
                        <tr :key="row">
                            <td :rowspan="row.data.length + 1">{{row.instituteName}}</td>
                        </tr>
                        <template v-for="tableData in row.data">
                            <tr :key="tableData">
                                <td>
                                    {{tableData.course}}
                                </td>
                                <td :key="tableData">
                                    {{tableData.enrolledStudent}}
                                </td>
                                <td :key="tableData">
                                    {{tableData.passedStudent}}
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>

            <v-snackbar v-model="snackbar.snackbar"
                        color="success"
                        :timeout="snackbar.timeout"
                        top>
                {{ callbackResponse.message }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
        </v-container>
    </v-content>
</template>

<script>
    import axios from "axios";
    import JsonExcelVue from "@/components/ImportExport/JsonExcel.vue"
    export default {
        name: "MountaineeringHistoryList",
        props: [
            'moduleName'
        ],
        components: {
            JsonExcelVue
        },
        computed: {
            customYear() {
                let year = []
                for (let i = 0; i < 99; i++) {
                    year.push(`20${i < 10 ? '0' : ''}${i}`)
                }
                return year
            },
            reportIsMonthWise() {
                return this.serverParams.ReportType === "monthwise";
            },
            items() {
                return [
                    {
                        text: this.$t('reports'),
                        exact: true,
                        to: '/reportModules'
                    },
                    {
                        text: this.$t('academic_report'),
                        exact: true,
                        to: '/reportModules/reportAcademic'
                    },
                    {
                        text: this.$t('monthly_yearly_academic_report'),
                        exact: true,
                        disabled: true
                    }
                ]
            }
        },
        methods: {
            getNow: function () {
                const today = new Date();
                const date = today.getFullYear();
                /* const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();*/
                this.serverParams.FromDate = date;
                this.serverParams.ToDate = date;
            },
            formResponse(data) {
                console.log({ data })
                if (data.message) {
                    this.snackbar.formModal = false
                    this.snackbar.createFormComponent = false;
                    this.dialogDelete = false;
                    this.snackbar.editFormComponent = false;
                    this.callbackResponse = data;
                    this.snackbar.snackbar = true
                    this.loadItems();
                } else {
                    this.snackbar.createFormComponent = false;
                    this.dialogDelete = false;
                    this.snackbar.editFormComponent = false;
                    this.snackbar.formModal = false
                }
            },
            async fetchData() {
                this.customHeader = [
                    {
                        name: "InstituteName"
                    },
                    {
                        name: "Course"
                    },
                    {
                        name: "Enrolled Student"
                    },
                    {
                        name: "Passed Student"
                    }
                ]
                const customData = []
                this.rows.map(res => {
                    let cData = []
                    cData.title = res.instituteName
                    console.log('tttt', res.instituteName)
                    cData.nestedData = res.data.map(res => {
                        const newObj = {
                            course: res.course,
                            enrolledStudent: res.enrolledStudent,
                            passedStudent: res.passedStudent,

                        }
                        return Object.values(newObj)
                    })
                    customData.push(cData)
                })
                return customData
            },
            async onDownload() {
                let param = {
                    ReportType: this.serverParams.ReportType,
                    FromDate: this.serverParams.FromDate + '-01-01',
                    ToDate: this.serverParams.ToDate + '-12-31',
                };
                await axios({
                    url: 'Academic/DownloadAcademicYealyReportListAsyc',
                    method: 'POST',
                    responseType: 'blob',
                    data: param
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AcademicYealyReportListAsyc.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                });
                //await axios({
                //    url: 'Report/DownloadSample',
                //    method: 'POST',
                //    responseType: 'blob'
                //}).then((response) => {
                //    const url = window.URL.createObjectURL(new Blob([response.data]));
                //    const link = document.createElement('a');
                //    link.href = url;
                //    link.setAttribute('download', 'NationalParkFile.xlsx'); //or any other extension
                //    document.body.appendChild(link);
                //    link.click();
                //});
            },

            dialogueClose() {
                this.historyData.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
            },

            async loadItems() {
                this.snackbar.isLoading = true;
                let param = {
                    ReportType: this.serverParams.ReportType,
                    FromDate: this.serverParams.FromDate + '-01-01',
                    ToDate: this.serverParams.ToDate + '-12-31',
                };
                axios.post('Academic/GetAcademicYealyReportListAsyc', param)
                    .then(response => {
                        this.rows = response.data;
                        // this.totalRecords = response.data.totalCount;
                        this.columns = []
                        this.snackbar.loading = false;
                        console.log('data', response.data)
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage == -1 ? this.totalRecords : params.currentPerPage });
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },

            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
            },

            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                this.historyData.editItemIndex = item.personInformationID
            },

            deleteItem(props) {
                this.dialogDelete = true;
                this.deleteFormData.url = "Mountain/DeleteHistoryInformationByIDAsync/" + props.personInformationID;
            },
        },
        mounted() {
            this.getNow()
        },
        data() {
            return {
                panels: [0],
                customHeader: [],
                tab: 'tab-monthlyReport',
                callbackResponse: {
                    timeout: 6000
                },
                columns: [],
                rows: [],
                ReportTypes: [
                    {
                        id: "yearwise", value: "yearwise"
                    }
                ],
                dialogDelete: false,
                deleteFormData: [],
                formdata: [],
                historyData: {
                    totalRows: 0,
                    editItemIndex: null
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "id",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10,
                    FromDate: null,
                    ToDate: null,
                    ReportType: "yearwise"
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    menu1: false,
                    menu2: false,
                    /* breadcrumbsItem: [
                         {
                             text: 'Dashboard',
                             disabled: false,
                             to: 'MountaineeringDashboard',
                             exact: true

                         },
                         {
                             text: 'Mountaineering History Information',
                             disabled: true,
                         },
                     ],*/
                    dynamicComponent: {
                        current: 'HistoryForm'
                    }
                }
            };
        },
    }
</script>

<style lang="scss" scoped>
    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: #1e88e5;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        background-color: #1e88e5;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;
    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
</style>
